import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { userService } from "../services";
export const PrivateRoute = ({ component: Component,roles, ...rest }) => (
    
    <Route {...rest} render={props => (
        
        (localStorage.getItem('user') && userService.hasRoles(roles))
            ? <Component {...props} />
            : <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
    )} />
)